import VehiclesScreen from './VehiclesScreen';

export default VehiclesScreen;
